<template>
  <div class="toggle-button-wrapper def-toggle-button">
    <label :for="inputId" class="toggle-button-label">
      {{ label }}<span v-if="required" aria-hidden="true"> *</span>
    </label>
    <label :class="['switch', { disabled }]">
      <input
        :id="inputId"
        type="checkbox"
        role="switch"
        :checked="value"
        :aria-checked="value ? 'true' : 'false'"
        :aria-label="ariaLabel || label"
        :aria-describedby="error ? errorId : null"
        :aria-required="required ? 'true' : null"
        :aria-invalid="error ? 'true' : null"
        :disabled="disabled"
        @change="toggle"
      />
      <span :class="['slider', 'round']"></span>
    </label>
    <div v-if="error" :id="errorId" class="toggle-error" role="alert" aria-live="assertive">
      {{ error }}
    </div>
  </div>
</template>

<script>
export default {
  name: 'ToggleButton',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    ariaLabel: {
      type: String,
      default: '',
    },
    onText: {
      type: String,
      default: 'text.on',
    },
    offText: {
      type: String,
      default: 'text.off',
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    error: {
      type: String,
      default: '',
    },
    required: {
      type: Boolean,
      default: false,
    },
    id: {
      type: String,
      default: null,
    },
  },
  data() {
    return {
      uniqueId: `toggle-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`,
    };
  },
  computed: {
    inputId() {
      return this.id || this.uniqueId;
    },
    errorId() {
      return `${this.inputId}-error`;
    },
  },
  methods: {
    toggle(event) {
      if (!this.disabled) {
        this.$emit('input', event.target.checked);
        this.$emit('change', event.target.checked);
      }
    },
  },
};
</script>

<style scoped>
.toggle-button-wrapper {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
  width: 100%;
}

.toggle-button-label {
  text-align: left;
  font-weight: 500;
  cursor: pointer;
  flex: 1;
  margin-bottom: 0.25rem;
}

.switch {
  position: relative;
  display: inline-block;
  width: 60px;
}

.switch input {
  opacity: 0;
  width: 0;
  height: 0;
}

/* Structural slider geometry; visual states are handled by .def-toggle-button */
.slider {
  position: absolute;
  cursor: pointer;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  transition: .4s;
  height: 25px;
  opacity: 0.7;
}

.slider:before {
  position: absolute;
  content: "";
  height: 25px;
  width: 25px;
  transition: .4s;
}

input:checked + .slider:before {
  transform: translateX(35px);
}

.toggle-error {
  font-size: 0.9em;
  margin-top: 0.25rem;
  display: flex;
  align-items: center;
  gap: 0.5em;
  text-align: left;
}
</style>
